import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { followListApi } from '../../api/followListApi';
import { useAuth } from '../../auth/AuthContext';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import JourneysPanel from './JourneysPanel';
import './explore.css';
import '../social-compose/social-compose.css';
import './journey-discovery.css';

export default function JourneyDiscoveryPage() {
  const { status, user, isAuthenticated } = useAuth();
  const [params] = useSearchParams();
  const following = params.get('scope') === 'FOLLOWING';
  const memberId = user?.memberId ?? user?.id;
  const [hasFollowing, setHasFollowing] = useState(null);
  useEffect(() => {
    setHasFollowing(null);
    if (!isAuthenticated || !following || !memberId) return undefined;
    const controller = new AbortController();
    followListApi.listFollowing(memberId, { limit: 1 }, { signal: controller.signal })
      .then((raw) => {
        if (controller.signal.aborted) return;
        const payload = raw?.data ?? raw;
        if (Array.isArray(payload?.items)) setHasFollowing(payload.items.length > 0 || Boolean(payload.hasMore));
      }).catch(() => { /* An unavailable follow summary must not block journey search. */ });
    return () => controller.abort();
  }, [isAuthenticated, memberId, following]);
  const { t } = useTravelTranslation();
  return (
    <main className="journey-discovery-page" aria-labelledby="journey-discovery-title">
      <header className="journey-discovery__intro">
        <h1 id="journey-discovery-title">{t('travel.journeyDiscovery.title')}</h1>
        <p>{t('travel.journeyDiscovery.subtitle')}</p>
      </header>
      {status === 'unknown' ? <p role="status">{t('travel.discover.loading')}</p> : (
        <JourneysPanel key={`${status}:${user?.memberId ?? user?.id ?? 'guest'}`}
          dedicated canBrowseFollowing={isAuthenticated} hasFollowing={hasFollowing}
          returnStateKey={`${status}:${memberId ?? 'guest'}`} />
      )}
    </main>
  );
}
